// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import 'jquery'
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import "../controllers/index.js"
import "../controllers/list_ajax_controller"
import "../controllers/comment_form_controller"
import "../controllers/rating_controller"
import "../controllers/comment_inline_controller"
import "../controllers/dropzone_controller"
import "../controllers/version_dropzone_controller"
import "../controllers/infinite_scroll_controller"
import "../controllers/concept_modal_controller"
import "../controllers/concept_like_controller"

Rails.start()
ActiveStorage.start()


$(function(){
	var total_product = 0;
	var flashFadeOutTimeout = 2500;

	function formatCurrency(amount) {
		var formatted = amount.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
		return '€ ' + formatted;
	}

	function showFlashMessage(message) {
		// Create Bootstrap alert similar to admin style
		var alertDiv = $('<div class="alert alert-success alert-dismissible" role="alert" style="position: absolute; top: 60px; right: 15px; max-width: 50%; z-index: 1050; margin-top: 0; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">' +
			'<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
			'<span aria-hidden="true">&times;</span>' +
			'</button>' +
			'<strong><i class="fa fa-check-circle"></i> Succes:</strong> ' + message +
			'</div>');
		
		// Append to content container
		$('.content .container').append(alertDiv);
		
		// Handle close button
		alertDiv.find('.close').on('click', function(e) {
			e.preventDefault();
			var alert = $(this).closest('.alert');
			alert.css('transition', 'opacity 0.3s');
			alert.css('opacity', '0');
			setTimeout(function() {
				alert.remove();
			}, 300);
		});
		
		// Auto-hide after 5 seconds
		setTimeout(function() {
			if (alertDiv.length && alertDiv.parent().length) {
				alertDiv.css('transition', 'opacity 0.3s');
				alertDiv.css('opacity', '0');
				setTimeout(function() {
					if (alertDiv.length && alertDiv.parent().length) {
						alertDiv.remove();
					}
				}, 300);
			}
		}, 5000);
	}

 	var intervalId, timeoutId;

	function updateCounter(counterField, increment) {
		var step = parseInt(counterField.data('step'));
		var max = parseInt(counterField.data('max'));
		var min = parseInt(counterField.data('min'));
		var currentVal = parseInt(counterField.val()) || 0;

		var newVal = currentVal + (increment ? step : -step);
		if (newVal < 0) newVal = 0;
		if (newVal < min) newVal = min;
		if (newVal > max && !counterField.data('unlocked')) newVal = max;

		counterField.val(newVal);
  	};

	function calculateTotal() {
		var total = 0;
		var formatted = 0;
		$('.row[data-product-price]').each(function() {
			var price = parseFloat($(this).data('product-price'));
			var quantity = parseInt($(this).find('.input-field-numeric').val());
			var subtotal = price * quantity;
			total += subtotal;
			total_product += quantity;
			formatted = formatCurrency(subtotal);
			$(this).find('.sub-total').text(formatted);
		});

		//formatted = formatCurrency(total);
		// $('.cart-sub-total').text(formatted);
		// $('.cart-order-total').text(formatted);
	}

	function updateCart() {

		var products = {};
		$('.input-field-numeric').each(function() {
			var productId = $(this).data('product-id');
			var quantity = $(this).val();
			products[productId] = quantity;
		});
		var updateUrl = $(this).data('update-url');

		$.ajax({
			url: updateUrl,
			type: 'POST',
			data: {
				products: products
			},
			success: function(response) {	
				// update divs
				$('.cart-quantity').text(response.quantity);
				$('.cart-header').html(response.header);
				$('.summary').html(response.summary);
				if (total_product > 64) {
					$('.order-block').show();
				} else {
					$('.order-block').hide();
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown);
			}
		});
	};

	$(document).on("mousedown", ".btn-numeric", function() {
		$(this).addClass('btn-numeric-active');
		if(timeoutId) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
	});

	$(document).on('change', '.input-field-numeric', function() {
		if(timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(updateCart, 1000);
	});

	$(document).on("mouseup mouseleave", ".btn-numeric", function() {
		$(this).removeClass('btn-numeric-active');
	});

	$(document).on("mousedown", ".plus, .minus", function(e) {
		e.preventDefault();
		var isIncrement = $(this).hasClass('plus');
		var counterField = $(this).parent().siblings('.counter-field');
		updateCounter(counterField, isIncrement);
		intervalId = setInterval(function() {
			updateCounter(counterField, isIncrement);
		}, 200);

		if(timeoutId) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
	});

	$(document).on("mouseup change", ".plus, .minus", function() {
		calculateTotal();
		clearInterval(intervalId);
		timeoutId = setTimeout(function() {
			updateCart();
		}, 300);
	});

	$('.show-product-details').click(function() {
		var productPageUrl = $(this).data('product-details-url');
		$.ajax({
			url: productPageUrl,
			type: 'GET',
			success: function(response) {
				$('#overlay').html(response).hide().fadeIn();
			},
			error: function(xhr, status, error) {
				console.log(error);
			}
		});
	});

	// Init Bootstrap 3 popovers for stock info (on focus to work with keyboard too)
    try {
        $(document).on('focus', '.stock-popover-trigger', function() {
            if (this._bs_popover_initialized) { return; }
            this._bs_popover_initialized = true;
            $(this).popover({ container: 'body', placement: 'auto' });
        });

        // Disable larger image hover popover on show page (replaced by fullscreen overlay)
        $(document).off('mouseenter', '.image-popover-trigger');
    } catch(e) {}

	$(document).on('submit', '.handle-add-to-cart', function(event) {
		event.preventDefault();

		var form = $(this);
		var url = form.attr('action');
		var method = form.attr('method');
		var data = form.serialize();

		$.ajax({
			url: url,
			method: method,
			data: data,
			dataType: 'json',
			success: function(response) {
				$('#overlay').fadeOut();
				var addedProductCount = response.quantity_added;
				showFlashMessage("<i class='fa fa-check fa-large'></i> " + addedProductCount + " product(en) succesvol aan winkelwagen toegevoegd.<br/> <a href='/store/carts'>Ga nu naar het winkelwagentje</a> of ga door met winkelen.");
				$('.cart-quantity').text(response.quantity); // Werk de winkelwagenpictogrammen bij
			},
			error: function(xhr, status, error) {
				alert("Er is een fout opgetreden: " + error); // Toon een foutmelding als er een fout is opgetreden tijdens het toevoegen aan de winkelwagen
			}
			});
	});

	// Artwork Versions: favorite and final toggles on show page
	$(document).on('click', '.js-fav-toggle', function(e) {
		e.preventDefault();
		var btn = $(this);
		var url = btn.data('url');
		if (!url) return;
		btn.prop('disabled', true);
		$.ajax({ url: url, method: 'POST', dataType: 'json', headers: { 'Accept': 'application/json' } })
		 .done(function(data){
			var icon = btn.find('i.fa-heart');
			if (data && data.favorited) {
				btn.addClass('selected');
				if (icon.length) { icon.removeClass('far').addClass('fas'); }
			} else {
				btn.removeClass('selected');
				if (icon.length) { icon.removeClass('fas').addClass('far'); }
			}
		 })
		 .fail(function(){
			alert('Favoriet aanpassen mislukt. Probeer opnieuw.');
		 })
		 .always(function(){ btn.prop('disabled', false); });
	});

	$(document).on('click', '.js-final-toggle', function(e) {
		e.preventDefault();
		var btn = $(this);
		var url = btn.data('url');
		if (!url) return;
		btn.prop('disabled', true);
		$.ajax({ url: url, method: 'PATCH', dataType: 'json', headers: { 'Accept': 'application/json' } })
     .done(function(data){
            // Reset all rows to non-final UI by default (render a clickable toggle button)
            $('.version-row').each(function(){
                var row = $(this);
                row.removeClass('selected');
                var group = row.find('.action-group');
                var wrap = group.find('.final-control');
                if (!wrap.length) { wrap = group; }
                var urlEach = row.data('select-final-url');
                wrap.html('<button class="action-button js-final-toggle" data-url="'+ urlEach +'" title="Als finale versie selecteren"><i class="far fa-check-circle"></i></button>');
            });

			// If a selected_version_id is present, apply final UI to that specific row
			if (data.selected_version_id) {
				var target = $('.version-row[data-version-id="'+ data.selected_version_id +'"]');
                if (target.length) {
                    target.addClass('selected');
                    var group = target.find('.action-group');
                    var wrap = group.find('.final-control');
                    if (!wrap.length) { wrap = group; }
                    var urlSel = target.data('select-final-url');
                    // Keep it clickable even when final (so user can un-final)
                    wrap.html('<button class="action-button selected js-final-toggle" data-url="'+ urlSel +'" title="Finale versie"><i class="fas fa-check-circle"></i></button>');
                }
			}
		 })
		 .fail(function(){
			alert('Finale versie selecteren mislukt.');
		 })
		 .always(function(){ btn.prop('disabled', false); });
	});

	$(document).on("click", ".close-overlay-on-click", function() {
		$('#overlay').fadeOut(300, function() {
			$('#overlay').empty();
		});
	});

	$(document).on("click", ".close-and-go-to-url", function() {
		alert($(this).attr('url'));
		$('#overlay').fadeOut(300, function() {
				$('#overlay').empty();
			});
		});
	});

	$(function(){
  		$.ajaxSetup({
    		headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  	});

	$(".add-to-favorites").click(function() {
		var productDiv = $(this).closest('.product');
		var productId = $(this).data('product-id');
		var url = $(this).data('add-to-favorites-url');
		
		$.ajax({
			url: url,
			method: 'POST',
			data: { id: productId },
			success: function(result) {
				productDiv.toggleClass('favorited');
				result.new_count > 0 ? $('.favorites-count').text(result.new_count) : $('.favorites-count').text('0');
			},
			error: function() {
				alert('Er is een fout opgetreden bij het toevoegen aan favorieten.');
			}
		});
	});
}); 
import "../admin/price_lists"
